import { render } from "./KsefCompanyDetail.vue?vue&type=template&id=cd50907a&scoped=true"
import script from "./KsefCompanyDetail.vue?vue&type=script&lang=js"
export * from "./KsefCompanyDetail.vue?vue&type=script&lang=js"

import "./KsefCompanyDetail.vue?vue&type=style&index=0&id=cd50907a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd50907a"]])

export default __exports__